import React from "react";

export default function TopRightRotation() {
  return (
    <img
      src="/assets/odontogram/rotasi-atas-kanan.png"
      alt="rotasi-atas-kanan"
      width="50"
      height="15"
    ></img>
  );
}
